import { zodResolver } from '@hookform/resolvers/zod';
import { type PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  BlockedRecordExamCenterManagerSchema,
  type BlockedRecordExamCenterManagerFormInput,
} from './schema';

interface BlockedRecordExamCenterManagerFormProviderProps extends PropsWithChildren {
  initialValues?: BlockedRecordExamCenterManagerFormInput;
}

export default function BlockedRecordExamCenterManagerFormProvider(
  props: Readonly<BlockedRecordExamCenterManagerFormProviderProps>,
) {
  const { children, initialValues } = props;

  const formContext = useForm<BlockedRecordExamCenterManagerFormInput>({
    resolver: zodResolver(BlockedRecordExamCenterManagerSchema),
    defaultValues: initialValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
